/* eslint-disable no-nested-ternary */
import React, {
  useContext,
  useRef,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import { typeValidation } from '../../../utils';
import { MenuContext } from '../../../MenuContext';

import NavigationListLinkWrapper from './styles/NavigationListLinkWrapper';

const NavigationListLink = ({
  sectionId,
  pointerEventsNone,
  ...props
}) => {
  const {
    navigationSectionActive,
    isWhiteColorHero,
    isHovered,
    userScrolledBelowTheHero,
  } = useContext(MenuContext);

  const ref = useRef(null);
  const defaultClassName = 'menu-navigation-link--large-screen';
  const activeClassName = 'menu-navigation-link--large-screen__active';
  const [classNameNavigation, setClassNameNavigation] = useState(defaultClassName);

  useEffect(() => {
    const isActiveSection = navigationSectionActive === sectionId;

    if (isActiveSection) {
      setClassNameNavigation(`${defaultClassName} ${activeClassName}`);
    }
  }, [navigationSectionActive]);

  return (
    <NavigationListLinkWrapper
      ref={ref}
      className={classNameNavigation}
      pointerEventsNone={pointerEventsNone}
      textColor={isWhiteColorHero || isHovered || userScrolledBelowTheHero ? 'black' : 'white'}
      pointBackgroundColor={isWhiteColorHero || isHovered || userScrolledBelowTheHero ? 'primary' : 'white'}
      {...props}
    />
  );
};

NavigationListLink.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  __TYPE: typeValidation('NavigationListLink'),
  pointerEventsNone: PropTypes.bool,
  sectionId: PropTypes.string,
};

NavigationListLink.defaultProps = {
  __TYPE: 'NavigationListLink',
  pointerEventsNone: false,
  sectionId: undefined,
};

export default NavigationListLink;

